// extracted by mini-css-extract-plugin
export default {"container":"Header_container__dKQex","text":"Header_text__bcaAs","hidden":"Header_hidden__PZcXD"};